import { render, staticRenderFns } from "./SegmentOfferDetails.vue?vue&type=template&id=36644726&scoped=true"
import script from "./SegmentOfferDetails.vue?vue&type=script&lang=ts"
export * from "./SegmentOfferDetails.vue?vue&type=script&lang=ts"
import style0 from "./SegmentOfferDetails.vue?vue&type=style&index=0&id=36644726&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36644726",
  null
  
)

export default component.exports